//create an api using createApi from @reduxjs/toolkit/query/react for the IStudentBookBag model
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { IStudentBookBag } from 'src/config/api/models/Book';
import { IGradeUser } from 'src/config/api/models/Grade';
import apiRoutesV2, { baseURL } from 'src/config/api/routes';
import { RootState } from 'src/modules/shared/store';

export const studentApi = createApi({
  reducerPath: 'studentApi',
  baseQuery: fetchBaseQuery({
    baseUrl: baseURL,
    prepareHeaders: (headers, { getState }) => {
      const token = (getState() as RootState).auth.jwt;
      if (token) {
        headers.set('authorization', `Bearer ${token}`);
      }
      return headers;
    },
  }),
  endpoints: (builder) => ({
    getStudentBookBag: builder.query<IStudentBookBag[], void>({
      query: () => ({
        url: apiRoutesV2.studentBookBag(),
        method: 'GET',
      }),
      transformResponse: (response: any) => response.data,
      keepUnusedDataFor: 0,
    }),
    getStudentsByGrade: builder.query<IGradeUser[], string>({
      query: (gradeId) => ({
        url: apiRoutesV2.gradeStudents(gradeId),
        method: 'GET',
      }),
      transformResponse: (response: any) => response.data,
    }),
    getStudentByGroup: builder.query<IGradeUser[], string>({
      query: (groupId) => ({
        url: apiRoutesV2.groupStudents(groupId),
        method: 'GET',
      }),
      transformResponse: (response: any) => response.data,
    }),
  }),
});

export const { useGetStudentBookBagQuery, useGetStudentsByGradeQuery, useGetStudentByGroupQuery } =
  studentApi;
